import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { resendVerificationEmail } from './verify-account.actions';

@Injectable({
  providedIn: 'root',
})
export class VerifyAccountDispatcher {
  constructor(private _store: Store<any>) {}

  resendVerificationEmail(shouldOpenDialog = true) {
    this._store.dispatch(resendVerificationEmail(shouldOpenDialog));
  }
}
